export const suppressViewerShortcut = (event: KeyboardEvent): boolean => {
  if (event.defaultPrevented || event.isComposing || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey)
    return true
  const target = event.target
  if (!(target instanceof HTMLElement)) return false
  return (
    target.isContentEditable ||
    target.closest(
      'input, textarea, select, [contenteditable], [role="textbox"], [role="dialog"], [role="menu"], [role="slider"]'
    ) != null ||
    (event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight' &&
      target.closest('button, a, summary, [role="button"], [role="slider"], [data-viewer-controls]') != null)
  )
}
